import * as React from "react";

import { cn } from "@/lib/utils";
import { useConnectedMatchLock } from "@/lib/connectedMatchLock";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, disabled, placeholder, "aria-label": ariaLabel, ...props }, ref) => {
    const connectedLock = useConnectedMatchLock();
    const lockedByAria = Boolean(ariaLabel && connectedLock.lockedInputAriaLabels.includes(String(ariaLabel)));
    const lockedByPlaceholder = Boolean(placeholder && connectedLock.lockedInputPlaceholders.includes(String(placeholder)));
    const locked = connectedLock.active && (lockedByAria || lockedByPlaceholder);
    const suppressPlaceholder = connectedLock.active && Boolean(placeholder && connectedLock.suppressedPlaceholders.includes(String(placeholder)));

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        disabled={disabled || locked}
        placeholder={suppressPlaceholder ? "" : placeholder}
        aria-label={ariaLabel}
        data-connected-shared-locked={locked || undefined}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
